export const initialUserState = (): UserState => ({
  current_user: {
    id: 0,
    email: '',
    name: '',
    document: '',
    clients: [
      {
        id: 0,
        name: '',
        username: '🗝️',
        password: '🗝️',
        client_id: '🗝️',
        client_secret: '🗝️',
        host: '',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ],
    filials: [
      {
        id: 0,
        fantasyName: '',
        code: '',
        qrcode: '',
        clientId: 0,
        addressId: 0,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      },
    ],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    roles: []
  },
  selectedFilialId: 0,
});
